import { render, staticRenderFns } from "./ZygoteOption.vue?vue&type=template&id=080f7abc&"
import script from "./ZygoteOption.vue?vue&type=script&lang=js&"
export * from "./ZygoteOption.vue?vue&type=script&lang=js&"
import style0 from "./ZygoteOption.vue?vue&type=style&index=0&id=080f7abc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports